/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/default */
/* eslint-disable import/namespace */
import React, { useEffect } from 'react';
import { useNavigate, useLocation, Route, Navigate, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { useSelector } from 'react-redux';

import env from './Utils/Constants/env';
import { getBrandTitle, getBrandDescription } from './Utils/brand-utils';

import LoggedInArea from './components/LoggedInArea';
import NotLoggedInArea from './components/NotLoggedInArea';

const publicRoutes = [
	'/app/forget-password',
	'/app/login',
	'/app/check-reset-code',
	'/app/reset-password',
	'/app/success',
	'/app/failed',
	'/app/cancelled',
];

const App = () => {
	const { auth } = useSelector((state) => state.auth);
	const location = useLocation();

	const navigate = useNavigate();
	const { Brand } = useSelector((state) => state.brand);

	const updateFavicon = (newFavicon) => {
		const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
		link.type = 'image/png';
		link.rel = 'icon';
		link.href = newFavicon;
		document.getElementsByTagName('head')[0].appendChild(link);
	};

	const updateTitle = () => {
		const title = getBrandTitle();
		const description = getBrandDescription();

		document.title = title;

		// Update meta description
		const metaDescription =
			document.querySelector('meta[name="description"]') ||
			document.querySelector('meta[name="Handson Taxi"]');
		if (metaDescription) {
			metaDescription.setAttribute('content', description);
		}
	};
	useEffect(() => {
		const isPublicRoute = publicRoutes.includes(location.pathname);
		// console.info('isPublicRoute', isPublicRoute);

		// Update title based on domain
		updateTitle();

		if (!auth.token && !isPublicRoute) {
			navigate('/app/login');
		}

		if (Brand?.brandData?.webIcon)
			updateFavicon(`${env.baseUri}public-file/${Brand?.brandData?.webIcon}`);
	}, [Brand?.brandData?.webIcon, auth.token, location]);
	return (
		<ConfigProvider
			theme={{
				token: {
					colorPrimary: Brand?.brandData?.webPrimary || 'orange',
					colorLink: Brand?.brandData?.webPrimary || 'orange',
				},
			}}>
			<Routes>
				{/* Logged-in Area */}
				<Route path='/app/main/*' element={<LoggedInArea roles={auth?.profile?.role} />} />

				{/* Not Logged-in Area */}
				<Route path='/app/*' element={<NotLoggedInArea />} />

				{/* Redirect to the appropriate area */}
				<Route path='/' element={<Navigate to='/app/main' />} />
			</Routes>
		</ConfigProvider>
	);
};

export default App;
